import { render, staticRenderFns } from "./StateChips.vue?vue&type=template&id=64d05c0b&scoped=true"
import script from "./StateChips.vue?vue&type=script&lang=js"
export * from "./StateChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d05c0b",
  null
  
)

export default component.exports